import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';

import { AppMessage } from './../../Common/appMessage';
import { Utility } from './../../Common/Services/utility';
import { AdmEligibilityMessagesServiceService } from './adm-eligibility-messages-service.service';

@Component({
  selector: 'app-adm-eligibility-messages',
  templateUrl: './adm-eligibility-messages.component.html',
  styleUrls: ['./adm-eligibility-messages.component.css'],
  providers: [AdmEligibilityMessagesServiceService, FeatureFlagService]
})
export class AdmEligibilityMessagesComponent implements OnInit, OnDestroy {
  messagesCount: number;
  messageText: string;
  constructor(private featureFlags: FeatureFlagService, private _eligibilityService: AdmEligibilityMessagesServiceService, private _utility: Utility, private _appMessage: AppMessage) { }

  private redirect(): void {
    window.location.replace("/ies/internal/eligibility-messages");
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_ELIGIBILITY_MESSAGES_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_ELIGIBILITY_MESSAGES_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    this._utility.addLoaderCount();
    this._eligibilityService.getFailedMessages()
      .subscribe((res: any) => {
        this._utility.onSuccessCallback(res, '', () => {
          this.messagesCount = res.response.count;
          this.messageText = this.messagesCount == 0 ? this._appMessage.getItem['UMsg00083'] : this.messagesCount == 1 ? 'Failed Message' : 'Failed Messages';
        });
      }, error => {
        this._utility.onErrorCallback(error);
      });
  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }

  onPushMessage() {
    this._utility.addLoaderCount();
    this._eligibilityService.pushMessages()
      .subscribe(res => {
        this._utility.onSuccessCallback(res, this._appMessage.getItem['UMsg00084']);
      }, error => this._utility.onErrorCallback(error));
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-eligibility-messages/adm-eligibility-messages.component.ts